const PREFIX_STYLE = `font-weight:bold;font-size:14px`;
const PREFIX_TEXT = `UdstillerGuide: `;

export function info(text: string, ...optionalParams: any[]) {
    prefixedLog(console.log, text, optionalParams);
}

export function warn(text: string, ...optionalParams: any[]) {
    prefixedLog(console.warn, text, optionalParams);
}

export function error(text: string, ...optionalParams: any[]) {
    prefixedLog(console.error, text, optionalParams);
}

function prefixedLog(logger: (message?: any, ...optionalParams: any[]) => void, text: string, extraOptionalParams: any[]) {
    logger(`%c${PREFIX_TEXT}%c${text}`, PREFIX_STYLE, "", ...extraOptionalParams)
}
